// extracted by mini-css-extract-plugin
export var dividerLine = "_76-3";
export var itemImage = "_76-9";
export var lightDivider = "_76-4";
export var modalContent = "_76-5";
export var modalContentCompact = "_76-6";
export var productCard = "_76-a";
export var productImage = "_76-b";
export var productImageCompact = "_76-7";
export var productImagePlaceholder = "_76-c";
export var productImagePlaceholderCompact = "_76-8";
export var progressBarBackground = "_76-1";
export var progressBarContainer = "_76-0";
export var progressBarFill = "_76-2";